import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { IDashBoardAdminChartDetailsWithProvider } from "../dasboard-admin-chart-details.model";
import { ChartValue } from "../chart/chart-value.model";
import { BarChartOptions } from "../chart/bar-chart-options.model";
import { DateHelperService } from "../../core/services/index";
import { IPublisher } from "../../shared/publisher.model";

@Component({
    selector: 'uniques-by-day',
    templateUrl: 'uniques-by-day.component.html'
})

export class UniquesByDayComponent implements OnInit, OnChanges {
    @Input() data: IDashBoardAdminChartDetailsWithProvider;
    @Input() period: string;
    @Input() showTopSectionOverlay: boolean;
    toolTipText: string = "{2} {0} {1} ";
    chartValues: ChartValue[];
    triggerChange: Date;
    chartOptions: BarChartOptions = new BarChartOptions();

    constructor(private dateHelper: DateHelperService) {
    }

    ngOnInit(){
        this.chartOptions.roundTooltip = true;
    }

    private mapAllData(): void {
        this.chartValues = new Array<ChartValue>();
        let publishers: IPublisher[] = new Array<IPublisher>();
        for (let item of this.data.uniquesByDay) {
            if (publishers.findIndex(s => s.id == item.publisher.id) === -1)
                publishers.push(item.publisher);
        }

        if (publishers.length > 0) {
            for (let publisher of publishers) {
                let chartValue = new ChartValue(publisher.name);
                chartValue.identifier = publisher.id;
                let uniquesByDay = this.data.uniquesByDay.filter(x => x.publisher.id == publisher.id);
                for (let item of uniquesByDay) {
                    chartValue.data.push([this.dateHelper.getTicks(item.uniques.dateUtc), item.uniques.count]);
                    chartValue.lastItemIdentifier = item.uniques.dateUtc;
                }
                this.chartValues.push(chartValue);
            }
        }
        for (let chart of this.chartValues) {
            chart.data = chart.data.sort((a: number, b: number) => {
                return a[0] - b[0];
            })
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.data && changes["data"] && changes["data"].previousValue != changes["data"].currentValue)
            this.mapAllData();

    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/uniques-by-day/uniques-by-day.component.ts